module.exports = function getResource(label, vars = []) {
    const resources = {
        modalTitleRegister: 'S’inscrire auprès de sephora',
        modalTitleCreate: 'Créer un compte',
        modalTitleComplete: 'Terminer la configuration du compte'
    };

    return resources[label];
};
